import { Tabs } from "@components/tabs-nav/TabNav.types";

export const CustomersTabs: Tabs = {
  Customer: {
    CRMClientDetails: { id: "ca-crmclientdetails", name: "CRM Client Details" },
    Applications: { id: "ca-applications", name: "BpCloud Applications" },
    CustomerAccount: { id: "ca-customeraccount", name: "Customer Account" }
  }
};
